// Predefiniowane etapy - będą dostępne w interfejsie użytkownika
export const PREDEFINED_STAGES = [
  'Instalacje wod - kan - gaz',
  'Wykończenia wnętrz, remonty',
  'Prace malarskie',
  'Glazurnictwo',
  'Biały montaż łazienki',
  'Tapetowanie',
  'Konstrukcja sufitów podwieszany',
  'Montaż płyt karton-gips',
  'Cyklinowanie',
  'Układanie podłogi',
  'Montaż kuchni',
  'Montaż drzwi',
  'Montaż okien',
  'Instalacje elektryczne',
  'Instalacje grzewcze',
  'Instalacje wentylacji z rekuper',
  'Instalacja centralnego odkurzacza',
  'Projekt budowlany',
  'Wznoszenie budynków',
  'Prace rozbiórkowe dachu',
  'Prace brukarskie',
  'Ogrodzenia',
  'Projektowanie i pielęgnacja ogrodów',
  'Nawodnienie ogrodu',
  'Oświetlenie ogrodu'
]

// Predefiniowane zadania - będą dostępne w interfejsie użytkownika
export const PREDEFINED_TASKS: Record<string, string[]> = {
  'Instalacje wod - kan - gaz': ['Instalacja wodna', 'Instalacja kanalizacyjna', 'Instalacja gazowa'],
  'Wykończenia wnętrz, remonty': [
    'Etap przygotowawczy – poznanie potrzeb inwestora',
    'Projekt koncepcyjny',
    'Projekt wykonawczy',
    'Etap realizacyjny'
  ],
  'Prace malarskie': [
    'Malowanie ścian',
    'Malowanie sufitów',
    'Malowanie elementów wykończeniowych',
    'Prace przygotowawcze',
    'Malowanie specjalistyczne'
  ],
  Glazurnictwo: [
    'Prace przygotowawcze',
    'Montaż płytek',
    'Prace wykończeniowe'
  ],
  'Biały montaż łazienki': [
    'Prace demontażowe',
    'Montaż podstawowy',
    'Montaż dodatkowy'
  ],
  Tapetowanie: [
    'Prace przygotowawcze',
    'Montaż tapet',
    'Prace wykończeniowe'
  ],
  'Konstrukcja sufitów podwieszany': [
    'Sufity standardowe',
    'Sufity kasetonowe',
    'Oświetlenie',
    'Elementy wykończeniowe'
  ],
  'Montaż płyt karton-gips': [
    'Montaż podstawowy',
    'Prace wykończeniowe',
    'Prace dodatkowe'
  ],
  Cyklinowanie: [
    'Przygotowanie podłoża',
    'Renowacja powierzchni drewanianej',
    'Usuwanie niedoskonałości',
    'Wykończenie powierzchni'
  ],
  'Układanie podłogi': [
    'Prace przygotowawcze',
    'Montaż podkładów',
    'Montaż podłóg',
    'Prace wykończeniowe'
  ],
  'Montaż kuchni': [
    'Projekt i wycena',
    'Prace demontażowe',
    'Prace montażowe i wykończenie',
    'Odbiór końcowy i test działania'
  ],
  'Montaż drzwi': [
    'Przygotowanie otworów drzwiowych',
    'Demontaż starych elementów',
    'Obróbka otworów drzwiowych',
    'Montaż nowych drzwi',
    'Podcinanie drzwi',
    'Montaż drzwi specjalnych i rewizyjnych',
    'Prace wykończeniowe'
  ],
  'Montaż okien': [
    'Demontaż starej stolarki okiennej',
    'Obróbka otworów okiennych',
    'Montaż ościeżnic i ram okiennych',
    'Montaż skrzydeł okiennych',
    'Montaż osłon okiennych i akcesoriów',
    'Prace wykończeniowe',
    'Wymiana drobnych elementów'
  ],
  'Instalacje elektryczne': [
    'Projekt',
    'Oświetlenie i oprawy',
    'Gniazda i punkty instalacyjne',
    'Instalacje specjalistyczne',
    'Prace instalacyjne i przygotowawcze'
  ],
  'Instalacje grzewcze': [
    'Etap projektowy i przygotowawczy',
    'Demontaż starej instalacji',
    'Prace przygotowawcze pod montaż instalacji',
    'Instalacja systemu grzewczego',
    'Montaż źródła ciepła (kocioł/piec)',
    'Próby szczelności i uruchomienie instalacji',
    'Odbiór i szkolenie użytkownika',
    'Serwis i opieka posprzedażowa'
  ],
  'Instalacje wentylacji z rekuper': [
    'Wstępna konsultacja',
    'Analiza dokumentacji technicznej',
    'Dobór systemów',
    'Wstępna koncepcja instalacji',
    'Obliczenia i pomiary',
    'Sporządzenie wyceny',
    'Omówienie oferty z Klientem',
    'Finalna wersja oferty',
    'Montaż instalacji wentylacyjnej (rekuperacja)',
    'Montaż instalacji klimatyzacji kanałowej',
    'Podłączenia elektryczne i automatyk',
    'Uruchomienie instalacji',
    'Odbiór i szkolenie użytkownika',
    'Serwis i opieka po montażu'
  ],
  'Instalacja centralnego odkurzacza': [
    'Etap planowania',
    'Projekt instalacji',
    'Etap instalacji rurowej (stan surowy zamknięty)',
    'Montaż jednostki centralnej (stan deweloperski / wykończeniowy)',
    'Montaż akcesoriów i gniazd końcowych',
    'Uruchomienie i testy',
    'Odbiór instalacji'
  ],
  'Projekt budowlany': [
    'Faza przygotowawcza',
    'Checklista dla Inwestora',
    'Faza wykonawcza'
  ],
  'Wznoszenie budynków': [
    'Przygotowanie prac budowlanych',
    'Stan zerowy',
    'Stan surowy otwarty',
    'Dach',
    'Ocieplenie i elewacje',
    'Prace wewnętrzne mokre i suche',
    'Posadzki i parapety'
  ],
  'Prace rozbiórkowe dachu': [
    'Demontaż papy dachowej',
    'Demontaż blachy dachowej i blachodachówki',
    'Demontaż eternitu',
    'Wywóz i utylizacja eternitu'
  ],
  'Prace brukarskie': [
    'Prace przygotowawcze',
    'Stabilizacja i przygotowanie podłoża',
    'Obrzeża i elementy ograniczające',
    'Instalacje dodatkowe',
    'Układanie nawierzchni',
    'Wykończenie',
    'Serwis i naprawy'
  ],
  Ogrodzenia: [
    'Ogrodzenie panelowe',
    'Ogrodzenie z siatki',
    'Ogrodzenie z płyt betonowych',
    'Ogrodzenie murowane'
  ],
  'Projektowanie i pielęgnacja ogrodów': [
    'Konsultacje i planowanie wstępne',
    'Projektowanie ogrodu',
    'Przygotowanie terenu',
    'Zakładanie ogrodu',
    'Zakładanie i pielęgnacja trawnika',
    'Pielęgnacja ogrodu'
  ],
  'Nawodnienie ogrodu': [
    'Etap przygotowawczy i projektowy',
    'Projektowanie hydrauliki i automatyki',
    'Etap wykonawczy – montaż systemu',
    'Etap testowania i szkolenia'
  ],
  'Oświetlenie ogrodu': [
    'Projekt koncepcyjny i planowanie',
    'Projekt wykonawczy',
    'Wykonawstwo',
    'Odbiór i przeszkolenie'
  ]
}

// Predefiniowane podzadania - będą dostępne w interfejsie użytkownika
export const PREDEFINED_SUBTASKS: Record<string, Record<string, string[]>> = {
  'Instalacje wod - kan - gaz': {
    'Instalacja wodna': ['Przyłącze wodne', 'Rozprowadzenie rur', 'Montaż zaworów', 'Testy ciśnieniowe'],
    'Instalacja kanalizacyjna': ['Przyłącze kanalizacyjne', 'Montaż rur spustowych', 'Montaż syfonów', 'Testy szczelności'],
    'Instalacja gazowa': ['Przyłącze gazowe', 'Montaż rur gazowych', 'Montaż zaworów gazowych', 'Testy szczelności']
  },
  'Wykończenia wnętrz, remonty': {
    'Etap przygotowawczy – poznanie potrzeb inwestora': [
      'Spotkanie wstępne z inwestorem',
      'Poznanie stylu życia i przyzwyczajeń domowników',
      'Ustalenie budżetu oraz zakresu projektu',
      'Określenie preferowanego stylu wnętrzarskiego',
      'Zdefiniowanie funkcji każdego pomieszczenia',
      'Dokładny pomiar pomieszczeń',
      'Weryfikacja instalacji',
      'Dokumentacja fotograficzna'
    ],
    'Projekt koncepcyjny': [
      'Opracowanie 2–3 wariantów układu funkcjonalnego',
      'Ustalenie lokalizacji ścian działowych',
      'Rozmieszczenie mebli, sprzętów i urządzeń',
      'Konsultacje i wybór finalnego układu',
      'Opracowanie tablicy inspiracyjnej',
      'Propozycje elementów wyposażenia'
    ],
    'Projekt wykonawczy': [
      'Wykonanie realistycznych wizualizacji pomieszczeń',
      'Konsultacje ws. opinii inwestora',
      'Rzuty z wymiarami i opisami technicznymi',
      'Projekt elektryki i oświetlenia',
      'Projekt instalacji wod-kan',
      'Rysunki mebli na wymiar',
      'Specyfikacja materiałowa',
      'Lista zakupów wraz z linkami do sklepów'
    ],
    'Etap realizacyjny': [
      'Wizyta projektanta na budowie',
      'Kontrola zgodności prac z projektem',
      'Doradztwo w trakcie realizacji',
      'Ostateczne ustawienie dodatków i dekoracji',
      'Przygotowanie wnętrza do sesji fotograficznej'
    ]
  },
  'Prace malarskie': {
    'Malowanie ścian': [
      'Malowanie ścian jednokrotne (farba-biała)',
      'Malowanie ścian dwukrotne (farba-biała)',
      'Malowanie ścian jednokrotne (farba-kolor)',
      'Malowanie ścian dwukrotne (farba-kolor)'
    ],
    'Malowanie sufitów': [
      'Malowanie sufitu jednokrotne (farba-biała)',
      'Malowanie sufitu dwukrotne (farba-biała)',
      'Malowanie sufitu jednokrotne (farba-kolor)',
      'Malowanie sufitu dwukrotne (farba-kolor)'
    ],
    'Malowanie elementów wykończeniowych': [
      'Malowanie drzwi',
      'Malowanie okien',
      'Malowanie rur wod - kan, lub c.o.',
      'Malowanie balustrad lub poręczy balkonowych',
      'Lakierowanie (farby olejne)'
    ],
    'Prace przygotowawcze': [
      'Malowanie podkładowe',
      'Gruntowanie',
      'Skrobanie starych powłok malarskich'
    ],
    'Malowanie specjalistyczne': [
      'Malowanie fantazyjne',
      'Malowanie artystyczne'
    ]
  },
  Glazurnictwo: {
    'Prace przygotowawcze': [
      'Skucie starej glazury',
      'Wyrównanie ścian i posadzki pod nowe płytki'
    ],
    'Montaż płytek': [
      'Wiercenie otworów w glazurze',
      'Wykonanie półki, wnęk i nietypowych powierzchni z glazury',
      'Wyszlifowanie krawędzi płytek na narożnikach'
    ],
    'Prace wykończeniowe': [
      'Zamocowanie narożnych listew',
      'Fugowanie',
      'Montaż drzwiczek rewizyjnych'
    ]
  },
  'Biały montaż łazienki': {
    'Prace demontażowe': [
      'Demontaż wanny, brodzika, umywalki'
    ],
    'Montaż podstawowy': [
      'Montaż kabiny prysznicowej',
      'Montaż umywalki',
      'Montaż pralki',
      'Montaż geberitu',
      'Montaż sedesu podwieszanego',
      'Montaż brodziku'
    ],
    'Montaż dodatkowy': [
      'Powieszenie lustra, szafki łazienkowej, półki'
    ]
  },
  Tapetowanie: {
    'Prace przygotowawcze': [
      'Zrywanie starych tapet',
      'Przygotowanie powierzchni do tapetowania',
      'Zagruntowanie podłoża klejem'
    ],
    'Montaż tapet': [
      'Tapetowanie Ścian',
      'Tapetowanie dwoma tapetami',
      'Tapetowanie sufitu'
    ],
    'Prace wykończeniowe': [
      'Wykończenie paskiem',
      'Przyklejenie bordy'
    ]
  },
  'Konstrukcja sufitów podwieszany': {
    'Sufity standardowe': [
      'Sufit podwieszany jednopoziomowy',
      'Sufit podwieszany dwupoziomowy',
      'Wykończenie sufitu',
      'Wykończenie sufitu po łuku'
    ],
    'Sufity kasetonowe': [
      'Sufit podwieszany kasetonowy',
      'Montaż lampy rastrowej - w suficie kasetonowym'
    ],
    Oświetlenie: [
      'Wpust liniowy na oświetlenie',
      'Wpust punktowy na oświetlenie',
      'Montaż halogenów wpuszczanych',
      'Montaż halogenów nawierzchniowych',
      'Montaż taśmy LED - jednokolorowa',
      'Montaż taśmy LED - RGB (wielokolorowa)'
    ],
    'Elementy wykończeniowe': [
      'Gzyms prosty',
      'Gzyms po łuku',
      'Wpust na karnisz',
      'Podcięcie zabudowy przy suficie'
    ]
  },
  'Montaż płyt karton-gips': {
    'Montaż podstawowy': [
      'Montaż płyt gips-karton na stelażu',
      'Montaż płyt gips-karton na klej',
      'Wykonanie otworu na drzwi w ściance z płyt gips-karton',
      'Zmiana kierunku ściany z płyty gips-karton'
    ],
    'Prace wykończeniowe': [
      'Szpachlowanie łączeń między płytami gipsowo-kartonowymi',
      'Wszpachlowanie siatki zbrojącej na pęknięciach i zarysowaniach',
      'Montaż narożników aluminiowych'
    ],
    'Prace dodatkowe': [
      'Montaż sztukaterii',
      'Wykonanie wnęki na oświetlenie'
    ]
  },
  Cyklinowanie: {
    'Przygotowanie podłoża': [
      'Gruntowanie posadzki',
      'Wylewanie mas samopoziomujących'
    ],
    'Renowacja powierzchni drewanianej': [
      'Cyklinowanie parkietu / desek / desek Barlineckich / podłogi z desek',
      'Cyklinowanie desek z farby olejnej',
      'Cyklinowanie bezpyłowe'
    ],
    'Usuwanie niedoskonałości': [
      'Szpachlowanie szczelin',
      'Polerowanie bezpyłowe'
    ],
    'Wykończenie powierzchni': [
      'Cyklinowanie bezpyłowe + 3-krotne lakierowanie',
      'Cyklinowanie bezpyłowe + olejowanie',
      'Lakierowanie dodatkowe',
      'Olejowanie dodatkowe',
      'Konserwacja podłóg olejowanych'
    ]
  },
  'Układanie podłogi': {
    'Prace przygotowawcze': [
      'Demontaż starej podłogi / wykładziny',
      'Przygotowanie podłoża',
      'Wylewanie mas samopoziomujących'
    ],
    'Montaż podkładów': [
      'Montaż folii paroizolacyjnej',
      'Montaż podkładu pod panele',
      'Montaż płyt MFP, OSB'
    ],
    'Montaż podłóg': [
      'Montaż paneli laminowanych',
      'Montaż paneli winylowych',
      'Montaż paneli drewnianych',
      'Montaż podłogi klejonej',
      'Montaż podłogi bez kleju',
      'Układanie terakoty',
      'Układanie podłogi w jodełkę'
    ],
    'Prace wykończeniowe': [
      'Montaż cokołów',
      'Montaż listew i progów przypodłogowych'
    ]
  },
  'Montaż kuchni': {
    'Projekt i wycena': [
      'Sporządzenie projektu kuchni zgodnie z potrzebami inwestora',
      'Przygotowanie szczegółowej wyceny uwzględniającej materiały, systemy cargo, fronty, blaty oraz dodatkowe elementy'
    ],
    'Prace demontażowe': [
      'Demontaż starych mebli kuchennych i ich wyniesienie',
      'Demontaż sanitariatów oraz urządzeń AGD (zlewu, zmywarki, płyty, piekarnika, lodówki itp.)',
      'Odłączenie instalacji wodno-kanalizacyjnej, elektrycznej i gazowej zgodnie z przepisami BHP'
    ],
    'Prace montażowe i wykończenie': [
      'Przygotowanie kuchni pod montaż',
      'Ewentualne wyrównanie ścian i podłogi pod zabudowę',
      'Prace elektryczne i hydrauliczne (przeniesienie gniazdek, podłączeń, odpływów, instalacja punktów oświetleniowych)',
      'Malowanie, glazura, montaż paneli ściennych lub fartucha szklanego, jeśli przewidziane w projekcie',
      'Wniesienie i złożenie zabudowy meblowej (szafki dolne i górne)',
      'Złożenie i powieszenie mebli kuchennych',
      'Wypoziomowanie i solidne mocowanie szafek do ścian',
      'Montaż szafek narożnych, systemów wysuwanych i koszy cargo, jeśli zaplanowane',
      'Docięcie i zamontowanie blatu kuchennego',
      'Precyzyjne wycięcie otworów pod zlewozmywak, płytę grzewczą i baterię',
      'Obróbka i zabezpieczenie krawędzi blatów przed wilgocią',
      'Montaż zlewozmywaka i baterii kuchennej, wraz z podłączeniem do instalacji wod.-kan',
      'Montaż oraz podłączenie płyty gazowej lub indukcyjnej (wymagane uprawnienia)',
      'Montaż piekarnika, zmywarki, lodówki, mikrofalówki – w zabudowie lub wolnostojących',
      'Montaż i podłączenie okapu kominowego lub podszafkowego (w tym poprowadzenie kanału wentylacyjnego)',
      'Montaż listew maskujących, cokołów i frontów zmywarki/lodówki',
      'Podłączenie oświetlenia podszafkowego (taśmy LED, lampki punktowe)',
      'Instalacja gniazdek w blacie lub wysuwanych kolumn zasilających'
    ],
    'Odbiór końcowy i test działania': [
      'Sprawdzenie szczelności i działania wszystkich podłączeń (woda, gaz, prąd)',
      'Test działania sprzętów AGD',
      'Instruktaż użytkownika dotyczący konserwacji i eksploatacji'
    ]
  },
  'Montaż drzwi': {
    'Przygotowanie otworów drzwiowych': [
      'Wykucie nowego otworu drzwiowego w ściance działowej',
      'Rozbiórka istniejących otworów drzwiowych'
    ],
    'Demontaż starych elementów': [
      'Demontaż skrzydeł drzwiowych, opasek oraz ościeżnic',
      'Oczyszczenie wnęki drzwiowej z resztek zaprawy i uszkodzeń, przygotowanie pod montaż nowej ościeżnicy'
    ],
    'Obróbka otworów drzwiowych': [
      'Wyrównanie i szpachlowanie wnęki pod nową ościeżnicę – istotne dla estetyki i szczelności',
      'Wzmocnienie krawędzi, usunięcie ubytków i zagruntowanie podłoża'
    ],
    'Montaż nowych drzwi': [
      'Montaż ościeżnicy (regulowanej lub stałej) – poziomowanie, klinowanie, piankowanie',
      'Zawieszenie skrzydła drzwiowego i wyregulowanie zawiasów',
      'Montaż klamki, zamka, zaczepów i innych okuć drzwiowych',
      'Montaż drzwi wewnętrznych, zewnętrznych, przesuwnych oraz typu "barn door"'
    ],
    'Podcinanie drzwi': [
      'Podcięcie skrzydła drzwiowego',
      'Dokładne oszlifowanie i zabezpieczenie krawędzi podcięcia'
    ],
    'Montaż drzwi specjalnych i rewizyjnych': [
      'Montaż drzwi rewizyjnych',
      'Dopasowanie kolorystyczne i techniczne (np. drzwi ognioodporne, maskowane, niewidoczne – typu "hidden")'
    ],
    'Prace wykończeniowe': [
      'Montaż opasek maskujących, listew wykończeniowych',
      'Usunięcie nadmiaru pianki montażowej i oczyszczenie obrzeży',
      'Korekty silikonowe lub akrylowe przy ościeżnicy',
      'Sprzątnięcie miejsca pracy i przekazanie gotowej stolarki Inwestorowi'
    ]
  },
  'Montaż okien': {
    'Demontaż starej stolarki okiennej': [
      'Demontaż okien – usunięcie skrzydeł oraz mechanizmów zamykających',
      'Demontaż ościeżnic okiennych',
      'Zabezpieczenie wnęki przed uszkodzeniem (taśmy, folie, osłony), przygotowanie podłoża pod nowy montaż'
    ],
    'Obróbka otworów okiennych': [
      'Czyszczenie i wyrównanie powierzchni ścian – usunięcie resztek zaprawy, tynku, kurzu',
      'Uzupełnienie ubytków oraz gruntowanie podłoża',
      'Sprawdzenie poziomu i pionu otworu'
    ],
    'Montaż ościeżnic i ram okiennych': [
      'Montaż ościeżnic okiennych – poziomowanie, zaklinowanie i trwałe mocowanie przy pomocy kotew lub dybli',
      'Wypełnienie szczelin montażowych pianką niskoprężną i zabezpieczenie jej taśmami paroszczelnymi oraz paroprzepuszczalnymi'
    ],
    'Montaż skrzydeł okiennych': [
      'Montaż okien plastikowych (PCV)',
      'Montaż okien drewnianych',
      'Montaż okien zespolonych',
      'Montaż okien wewnętrznych',
      'Montaż okien dachowych',
      'Montaż okien balkonowych i tarasowych'
    ],
    'Montaż osłon okiennych i akcesoriów': [
      'Montaż rolet zewnętrznych – natynkowych lub podtynkowych (również sterowanych elektrycznie)',
      'Montaż rolet wewnętrznych – dzień/noc, rzymskich, plisowanych itp.',
      'Montaż świetlików dachowych i tuneli świetlnych – dla doświetlenia korytarzy, łazienek, poddaszy'
    ],
    'Prace wykończeniowe': [
      'Obróbka tynkarska wokół okien (od wewnątrz i zewnątrz)',
      'Montaż parapetów wewnętrznych i zewnętrznych',
      'Uszczelnienie i estetyczne wykończenie styku ramy z murem'
    ],
    'Wymiana drobnych elementów': [
      'Wymiana klamek i szyldów okiennych',
      'Regulacja skrzydeł i okuć, kontrola poprawności działania, sprawdzenie wentylacji (mikrowentylacja, nawiewniki)'
    ]
  },
  'Instalacje elektryczne': {
    Projekt: [
      'Projekt instalacji elektrycznych'
    ],
    'Oświetlenie i oprawy': [
      'Montaż lamp sufitowych (plafonów, zwisów, spotów)',
      'Montaż kinkietów ściennych',
      'Montaż halogenów wpuszczanych (podtynkowych)',
      'Montaż halogenów natynkowych',
      'Montaż taśmy LED – jednokolorowej',
      'Montaż taśmy LED – RGB (wielokolorowej)',
      'Montaż sterowników LED do taśm jednokolorowych',
      'Montaż sterowników LED do taśm RGB (wielokolorowych)',
      'Instalacja systemów oświetlenia z czujnikami ruchu',
      'Montaż ściemniaczy oświetlenia (tradycyjnych i dotykowych)'
    ],
    'Gniazda i punkty instalacyjne': [
      'Montaż gniazd elektrycznych (natynkowych i podtynkowych)',
      'Montaż łączników (włączników jedno-, dwu- i trójklawiszowych)',
      'Wykucie gniazda pod puszkę i montaż osprzętu',
      'Montaż gniazd siłowych (np. do kuchni indukcyjnych)',
      'Punkt gniazda T.V.',
      'Punkt gniazda telefonicznego',
      'Punkt internetowy (RJ45)',
      'Punkt akustyczny (nagłośnienie sufitowe lub ścienne)',
      'Punkt oświetlenia górnego'
    ],
    'Instalacje specjalistyczne': [
      'Montaż i konfiguracja maty grzewczej',
      'Montaż sterownika do maty grzewczej (termostaty, programatory)',
      'Montaż wentylatora łazienkowego (z czujnikiem ruchu lub higrostatem)',
      'Podłączenie kuchenki elektrycznej (1-fazowej i 3-fazowej)',
      'Montaż domofonu lub wideodomofonu',
      'Montaż dzwonka lub systemu przywoławczego',
      'Montaż skrzynki rozdzielczej (tablicy rozdzielczej) z bezpiecznikami',
      'Montaż ochrony przeciwprzepięciowej i różnicowoprądowej (RCB)',
      'Montaż gniazd z zabezpieczeniem SMART (zdalne sterowanie)',
      'Podłączenie i montaż urządzeń SMART HOME (inteligentne oświetlenie, gniazda, rolety)'
    ],
    'Prace instalacyjne i przygotowawcze': [
      'Położenie kabla elektrycznego (w peszlu lub bez)',
      'Wykucie bruzdy pod przewody oraz zaszpachlowanie',
      'Wykonanie kanału telewizyjnego (maskowanie przewodów RTV/SAT)',
      'Wymiana istniejącej instalacji na nową',
      'Diagnoza i naprawa usterek w instalacji elektrycznej',
      'Pomiary elektryczne',
      'Odbiór instalacji'
    ]
  },
  'Instalacje grzewcze': {
    'Etap projektowy i przygotowawczy': [
      'Konsultacja z inwestorem, analiza zapotrzebowania na ciepło',
      'Dobór systemu grzewczego (grzejniki, podłogówka, źródło ciepła)',
      'Wykonanie projektu instalacji lub jego weryfikacja',
      'Zaplanowanie lokalizacji pieca/kotła, rozdzielaczy, grzejników i termostatów',
      'Wycena materiałowa i ustalenie harmonogramu prac'
    ],
    'Demontaż starej instalacji': [
      'Demontaż starej instalacji grzewczej (rury, grzejniki, armatura)',
      'Demontaż starego pieca gazowego lub innego źródła ciepła',
      'Zabezpieczenie instalacji wodno-kanalizacyjnej i elektrycznej'
    ],
    'Prace przygotowawcze pod montaż instalacji': [
      'Wykonanie bruzd pod rury (ściany, podłogi) wraz z zatarciem i zabezpieczeniem',
      'Wykonanie przepustów, przejść technologicznych i otworów pod rozdzielacze',
      'Montaż szafek do rozdzielaczy C.O. i ogrzewania podłogowego'
    ],
    'Instalacja systemu grzewczego': [
      'Montaż rozdzielacza ogrzewania centralnego',
      'Wykonanie podejść pod grzejniki (rury plastikowe, miedziane lub alu-pex)',
      'Zawieszenie grzejników i podłączenie ich do instalacji',
      'Przesunięcie przyłączy do grzejnika',
      'Wykonanie izolacji termicznej i przeciwwilgociowej podłogi',
      'Ułożenie rur grzewczych zgodnie z projektem (pętlowo/spiralnie)',
      'Podłączenie rur do rozdzielacza',
      'Próba szczelności przed zalaniem wylewką'
    ],
    'Montaż źródła ciepła (kocioł/piec)': [
      'Montaż pieca gazowego z podłączeniem do instalacji gazowej i kominowej',
      'Montaż pieca elektrycznego z podłączeniem do zasilania',
      'Montaż kotła na pellet / ekogroszek / olej opałowy z układem podawania paliwa',
      'Wykonanie niezbędnych zabezpieczeń: zawory bezpieczeństwa, naczynie wzbiorcze, odpowietrzniki',
      'Podłączenie systemu sterowania (regulatory, czujniki, termostaty)'
    ],
    'Próby szczelności i uruchomienie instalacji': [
      'Przeprowadzenie próby ciśnieniowej całej instalacji grzewczej',
      'Napełnienie instalacji wodą grzewczą i odpowietrzenie',
      'Sprawdzenie działania poszczególnych grzejników i pętli podłogówki',
      'Rozruch i konfiguracja źródła ciepła',
      'Ustawienie krzywej grzewczej, harmonogramów, stref grzewczych (jeśli system zaawansowany)'
    ],
    'Odbiór i szkolenie użytkownika': [
      'Przekazanie protokołów z prób ciśnieniowych i rozruchu',
      'Instruktaż z obsługi kotła i sterowania ogrzewaniem',
      'Wydanie dokumentacji technicznej i kart gwarancyjnych'
    ],
    'Serwis i opieka posprzedażowa': [
      'Uzgodnienie harmonogramu przeglądów sezonowych',
      'Podpisania umowy serwisowej',
      'Monitorowanie zużycia energii i optymalizacja ustawień'
    ]
  },
  'Instalacje wentylacji z rekuper': {
    'Wstępna konsultacja': [
      'Zebranie podstawowych informacji od klienta',
      'Oględziny obiektu lub placu budowy',
      'Uzyskanie niezbędnych uzgodnień (np. od inwestora, kierownika budowy)'
    ],
    'Analiza dokumentacji technicznej': [
      'Przegląd rzutów architektonicznych budynku',
      'Sprawdzenie wysokości kondygnacji, konstrukcji stropów',
      'Weryfikacja lokalizacji pomieszczeń technicznych'
    ],
    'Dobór systemów': [
      'Dobór centrali rekuperacyjnej',
      'Dobór jednostki klimatyzacyjnej kanałowej',
      'Określenie rozprowadzenia kanałów wentylacyjnych i klimatyzacyjnych',
      'Dobór nawiewników, anemostatów, skrzynek rozprężnych i tłumików hałasu'
    ],
    'Wstępna koncepcja instalacji': [
      'Opracowanie schematu przebiegu kanałów wentylacyjnych i klimatyzacyjnych',
      'Zaproponowanie rozmieszczenia elementów instalacji w budynku'
    ],
    'Obliczenia i pomiary': [
      'Wykonanie obliczeń zapotrzebowania na powietrze',
      'Obliczenie zapotrzebowania na moc chłodniczą',
      'Weryfikacja oporów przepływu powietrza i zapotrzebowania energetycznego'
    ],
    'Sporządzenie wyceny': [
      'Przygotowanie wyceny materiałów (lista zakupów)',
      'Oszacowanie kosztów montażu'
    ],
    'Omówienie oferty z Klientem': [
      'Przedstawienie wyceny oraz proponowanego rozwiązania',
      'Ewentualne wprowadzenie poprawek i ponowna kalkulacja'
    ],
    'Finalna wersja oferty': [
      'Przesłanie kompletnej oferty wraz z rzutami poglądowymi',
      'Uzgodnienie terminu realizacji i warunków współpracy'
    ],
    'Montaż instalacji wentylacyjnej (rekuperacja)': [
      'Montaż centrali rekuperacyjnej (w pomieszczeniu technicznym lub na poddaszu)',
      'Rozprowadzenie kanałów wentylacyjnych (nawiewnych i wywiewnych)',
      'Montaż skrzynek rozdzielczych, tłumików hałasu, przepustnic, nawiewników i wywiewników',
      'Izolacja kanałów (zgodnie z normami np. przeciw kondensacji i strat ciepła)',
      'Podłączenie czerpni i wyrzutni powietrza',
      'Montaż systemu automatyki i sterowania'
    ],
    'Montaż instalacji klimatyzacji kanałowej': [
      'Montaż jednostki wewnętrznej i zewnętrznej (jeśli system jest split)',
      'Rozprowadzenie kanałów nawiewnych i ewentualnie powrotnych',
      'Montaż skrzynek rozprężnych, kratki nawiewne i powrotne',
      'Instalacja systemu odprowadzania skroplin',
      'Podłączenie sterowania i automatyki (termostaty, piloty, panele dotykowe)'
    ],
    'Podłączenia elektryczne i automatyk': [
      'Wykonanie zasilania elektrycznego dla urządzeń',
      'Podłączenie sterowników, czujników i paneli sterujących',
      'Integracja systemów (opcjonalnie: BMS, Smart Home)'
    ],
    'Uruchomienie instalacji': [
      'Przeprowadzenie próby szczelności i drożności kanałów',
      'Kalibracja instalacji wentylacyjnej (regulacja przepływów powietrza)',
      'Konfiguracja sterowania systemem klimatyzacji',
      'Sprawdzenie poprawności działania wszystkich funkcji'
    ],
    'Odbiór i szkolenie użytkownika': [
      'Odbiór techniczny instalacji',
      'Przekazanie instrukcji obsługi i kart gwarancyjnych',
      'Szkolenie użytkownika w zakresie obsługi systemów',
      'Podpisanie protokołu odbioru końcowego'
    ],
    'Serwis i opieka po montażu': [
      'Uzgodnienie harmonogramu przeglądów i serwisu okresowego',
      'Możliwość zawarcia umowy serwisowej',
      'Monitoring pracy urządzeń'
    ]
  },
  'Instalacja centralnego odkurzacza': {
    'Etap planowania': [
      'Konsultacja z inwestorem i analiza potrzeb',
      'Przegląd projektu budynku lub wstępne pomiary na miejscu',
      'Dobór odpowiedniej jednostki centralnej (moc, typ filtracji, pojemność)',
      'Zaplanowanie tras instalacji rurowej oraz rozmieszczenia gniazd ssących'
    ],
    'Projekt instalacji': [
      'Opracowanie schematu instalacji',
      'Wykonanie rzutów technicznych',
      'Przygotowanie specyfikacji materiałowej'
    ],
    'Etap instalacji rurowej (stan surowy zamknięty)': [
      'Wykonanie przepustów w ścianach i stropach (jeśli konieczne)',
      'Rozprowadzenie rur ssących (PCV) do planowanych punktów gniazd',
      'Montaż puszek gniazd ssących i ich wypoziomowanie',
      'Zabezpieczenie końcówek rur przed zabrudzeniem podczas prac budowlanych',
      'Sprawdzenie szczelności i drożności instalacji'
    ],
    'Montaż jednostki centralnej (stan deweloperski / wykończeniowy)': [
      'Zamontowanie jednostki centralnej w pomieszczeniu',
      'Podłączenie rur ssących do centrali',
      'Montaż tłumika hałasu oraz ewentualnego wyprowadzenia powietrza na zewnątrz',
      'Wykonanie odpływu do kanalizacji',
      'Podłączenie instalacji elektrycznej i automatyki'
    ],
    'Montaż akcesoriów i gniazd końcowych': [
      'Zamontowanie gniazd ssących i ich ram dekoracyjnych',
      'Montaż gniazda w szufelce automatycznej',
      'Instalacja systemu węża chowanego w ścianie',
      'Montaż zestawu akcesoriów: wąż ssący, rury teleskopowe, szczotki, uchwyty'
    ],
    'Uruchomienie i testy': [
      'Test szczelności instalacji',
      'Sprawdzenie poprawności działania gniazd ssących',
      'Weryfikacja uruchamiania centrali z poziomu gniazd',
      'Kalibracja mocy ssania (jeśli system przewiduje)',
      'Instruktaż użytkownika dotyczący obsługi, konserwacji i wymiany filtrów'
    ],
    'Odbiór instalacji': [
      'Sporządzenie protokołu odbioru',
      'Przekazanie instrukcji obsługi i karty gwarancyjnej'
    ]
  },
  'Projekt budowlany': {
    'Faza przygotowawcza': [
      'Określenie potrzeb inwestora',
      'Studium uwarunkowań, MPZP, WZ',
      'Analiza lokalizacji',
      'Zamówienie mapy do celów projektowych',
      'Badania geotechniczne gruntu',
      'Projekt koncepcyjny, wstępne wizualizacje',
      'Opracowanie wstępnej koncepcji architektonicznej',
      'Konsultacje z inwestorem',
      'Projekt zagospodarowania działki lub terenu',
      'Projekt architektoniczno-budowlany',
      'Projekt techniczny'
    ],
    'Checklista dla Inwestora': [
      'Pozyskanie pozwolenia na budowę',
      'Uzyskanie decyzji o pozwoleniu na budowę',
      'Zgłoszenie rozpoczęcia robót do PINB'
    ],
    'Faza wykonawcza': [
      'Spotkanie z kierowniem budowy',
      'Zakończenie budowy i zgłoszenie gotowości do odbioru',
      'Wyznaczenie terminu odbioru'
    ]
  },
  'Wznoszenie budynków': {
    'Przygotowanie prac budowlanych': [
      'Wstępne kosztorysy',
      'Audyt kosztów',
      'Wybór podwykonawców',
      'Ustalenie wstępnych terminów',
      'Przygotowanie sprzętu',
      'Wybór finalnych terminów',
      'Przekazanie szczegółowych informacji ekipie',
      'Spotkanie z kierownikiem budowy'
    ],
    'Stan zerowy': [
      'Wykopy pod ławy, deskowanie, zbrojenie, betonowanie',
      'Wyrównanie i przygotowanie terenu pod dalsze etapy',
      'Murowanie z bloczków betonowych',
      'Zalewanie szalunków betonem',
      'Wykonanie zbrojeń i wzmocnień pod obciążenia',
      'Hydroizolacja i termoizolacja',
      'Zabezpieczenie przed wilgocią i przemarzaniem'
    ],
    'Stan surowy otwarty': [
      'Murowanie ścian z betonu komórkowego',
      'Murowanie ścian z silikatów',
      'Murowanie ścian z ceramiki',
      'Przegrody wewnętrzne lekkie lub murowane',
      'Ułożenie belek i pustaków stropowych',
      'Zbrojenie wieńców i zalanie betonem',
      'Murowanie kanałów wentylacyjnych i dymowych',
      'Wypuszczenie ponad dach, pozostawienie do późniejszego obrobienia',
      'Wstawienie stolarki okiennej z uszczelnieniem i podkuciem otworów'
    ],
    Dach: [
      'Konstrukcja drewniana (więźba dachowa)',
      'Montaż folii dachowej',
      'Montaż łat i kontrłat',
      'Montaż dachówki ceramicznej lub betonowej',
      'Montaż blachodachówki',
      'Obróbki blacharskie',
      'Montaż rynien i rur spustowych',
      'Montaż okien dachowych',
      'Montaż wyłazów dachowych',
      'Montaż kominków wentylacyjnych',
      'Montaż płotków przeciwśniegowych',
      'Montaż instalacji odgromowej'
    ],
    'Ocieplenie i elewacje': [
      'Klejenie styropianu lub wełny mineralnej',
      'Kołkowanie ocieplenia',
      'Zatapianie siatki zbrojącej',
      'Wykonanie warstwy zbrojonej',
      'Gruntowanie pod tynk',
      'Wykonanie tynku elewacyjnego',
      'Wykończenie kolorystyczne elewacji',
      'Montaż parapetów zewnętrznych',
      'Montaż elementów ozdobnych (gzymsy, bonie, listwy)',
      'Montaż podbitki dachowej',
      'Montaż rolet zewnętrznych lub żaluzji fasadowych'
    ],
    'Prace wewnętrzne mokre i suche': [
      'Tynki tradycyjne cementowo-wapienne',
      'Tynki gipsowe',
      'Gładzie gipsowe',
      'Wylewki cementowe',
      'Montaż ścianek działowych z płyt g-k',
      'Montaż sufitów podwieszanych',
      'Wykończenie pod malowanie',
      'Montaż instalacji wewnętrznych (elektryka, wod-kan, c.o.)'
    ],
    'Posadzki i parapety': [
      'Wykonanie posadzki cementowej',
      'Wykonanie posadzki anhydrytowej',
      'Montaż izolacji przeciwwilgociowej pod posadzką',
      'Montaż ogrzewania podłogowego',
      'Montaż paneli podłogowych',
      'Montaż płytek podłogowych',
      'Montaż parapetów wewnętrznych i zewnętrznych'
    ]
  },
  'Prace rozbiórkowe dachu': {
    'Demontaż papy dachowej': [],
    'Demontaż blachy dachowej i blachodachówki': [],
    'Demontaż eternitu': [],
    'Wywóz i utylizacja eternitu': []
  },
  'Prace brukarskie': {
    'Prace przygotowawcze': [
      'Projekt',
      'Dodatkowe usługi minikoparką',
      'Wybranie ziemi pod koryto ścieżki gr. 20cm'
    ],
    'Stabilizacja i przygotowanie podłoża': [
      'Zagęszczenie podłoża piaskiem lub żwirem do 20 cm grubości',
      'Zagęszczenie podłoża piaskiem lub żwirem do 50 cm grubości',
      'Zagęszczenie podłoża piaskiem lub żwirem z podsypką cementową 5 cm – łącznie do 20 cm grubości',
      'Zagęszczenie podłoża piaskiem lub żwirem z podsypką cementową 10 cm – łącznie do 50 cm grubości',
      'Stabilizacja podłoża grysem do grubości 5 cm',
      'Stabilizacja podłoża grysem do grubości 10 cm',
      'Ułożenie włókniny',
      'Rozsypanie oraz ubicie warstwy odsączającej z pospółki gr. 10cm',
      'Przygotowanie podłoża pod kostkę (obciążenie do 3,5 t.)',
      'Przygotowanie podłoża pod kostkę (obciążenie do 10 t.)',
      'Przygotowanie podłoża pod kostkę (obciążenie powyżej 10 t.)',
      'Rozsypanie oraz ubicie warstwy piasku gr. 5cm'
    ],
    'Obrzeża i elementy ograniczające': [
      'Montaż obrzeża wys. 20cm',
      'Osadzanie obrzeży betonowych gr 6cm',
      'Montaż obrzeży trawnikowych',
      'Montaż obrzeży chodnikowych',
      'Montaż obrzeży palisadowych',
      'Ułożenie krawężników drogowych',
      'Montaż palisad'
    ],
    'Instalacje dodatkowe': [
      'Ułożenie instalacji odwadniającej'
    ],
    'Układanie nawierzchni': [
      'Ułożenie kostki granitowej 4/6',
      'Ułożenie kostki granitowej 7/9',
      'Ułożenie kostki granitowej 8/10',
      'Ułożenie kostki granitowej 15/17',
      'Ułożenie kostki granitowej – skomplikowane wzory',
      'Ułożenie Kostki betonowej klasycznej o grubości 6cm',
      'Ułożenie Kostki betonowej klasycznej o grubości 8cm',
      'Ułożenie Kostki typu Piccolo, Nova Granit i pokrewne',
      'Ułożenie Bruku Klinkierowego',
      'Ułożenie szlachetnej kostki brukowej',
      'Ułożenie szlachetnej kostki brukowej we wzory',
      'Ułożenie płyt chodnikowych',
      'Ułożenie płyt ażurowych',
      'Ułożenie płyt tarasowych',
      'Ułożenie Kamienia Sjeneńskiego',
      'Wykonanie tarasu wentylowanego',
      'Ułożenie płyt trawnikowych',
      'Ułożenie oraz ubicie kostki brukowej'
    ],
    Wykończenie: [
      'Rozsypanie suchego piasku w szczeliny'
    ],
    'Serwis i naprawy': [
      'Naprawy pogwarancyjne'
    ]
  },
  Ogrodzenia: {
    'Ogrodzenie panelowe': [
      'Demontaż starego ogrodzenia',
      'Przygotowanie terenu',
      'Niwelowanie terenu',
      'Montaż słupków',
      'Montaż łączników betonowych',
      'Montaż łączników metalowych',
      'Montaż podmurówki',
      'Montaż paneli',
      'Montaż bramy',
      'Montaż furtki',
      'Montaż kompletnego ogrodzenia (sprawdzanie ciągłości, dopasowanie elementów)'
    ],
    'Ogrodzenie z siatki': [
      'Demontaż starego ogrodzenia',
      'Przygotowanie terenu',
      'Niwelowanie terenu',
      'Montaż słupków (w beton lub na kotwach)',
      'Montaż łączników betonowych',
      'Montaż łączników metalowych  (np. napinacze, uchwyty)',
      'Montaż podmurówki betonowej',
      'Montaż siatki ogrodzeniowej',
      'Montaż drutów naciągowych',
      'Montaż furtki i bramy',
      'Montaż kompletnego ogrodzenia (sprawdzanie ciągłości, dopasowanie elementów)'
    ],
    'Ogrodzenie z płyt betonowych': [
      'Demontaż starego ogrodzenia',
      'Przygotowanie terenu',
      'Montaż płyt betonowych',
      'Montaż słupków betonowych',
      'Wykończenie (np. daszki, zabezpieczenia)'
    ],
    'Ogrodzenie murowane': [
      'Ustalenie preferencji inwestora (styl, kolor itp.)',
      'Demontaż starego ogrodzenia',
      'Przygotowanie terenu',
      'Niwelowanie terenu',
      'Wykopanie fundamentu',
      'Uzbrojenie fundamentu',
      'Zabetonowanie fundamentu',
      'Murowanie słupka',
      'Zbrojenie słupka',
      'Murowanie cokołu',
      'Zbrojenie i wylewanie wieńców słupków',
      'Montaż przęsła ogrodzeniowego (metalowe)',
      'Montaż przęsła ogrodzeniowego  (drewniane)',
      'Montaż przęsła ogrodzeniowego (aluminiowe)',
      'Montaż bramy',
      'Montaż furtki'
    ]
  },
  'Projektowanie i pielęgnacja ogrodów': {
    'Konsultacje i planowanie wstępne': [
      'Przegląd i analiza potrzeb klienta',
      'Konsultacje w zakresie zakładania, pielęgnacji ogrodu i systemów nawadniających',
      'Inwentaryzacja terenu i gleby',
      'Ocena nasłonecznienia, spadków terenu, istniejącej roślinności',
      'Opracowanie wstępnej koncepcji ogrodu',
      'Określenie stylu ogrodu, preferencji estetycznych i funkcjonalnych'
    ],
    'Projektowanie ogrodu': [
      'Projekt wykonawczy (rozmieszczenie stref: wypoczynkowej, rekreacyjnej, rabat, trawnika itp.)',
      'Dobór roślin: drzewa, krzewy, byliny, pnącza',
      'Projekt nawierzchni, obrzeży, małej architektury i elementów wodnych',
      'Projekt systemu nawadniającego',
      'Wizualizacje 2D/3D',
      'Rysunek techniczny ogrodu',
      'Sporządzenie dokumentacji wykonawczej i kosztorys'
    ],
    'Przygotowanie terenu': [
      'Usuwanie istniejącej roślinności i chwastów (również środkami chemicznymi)',
      'Praca glebogryzarką klasyczną lub separacyjną',
      'Wyrównanie terenu',
      'Dostarczenie i rozprowadzenie ziemi urodzajnej lub torfu',
      'Zakładanie siatek przeciw kretom',
      'Wytyczanie rabat, ścieżek i krawędzi'
    ],
    'Zakładanie ogrodu': [
      'Montaż systemu automatycznego nawadniania',
      'Układanie geowłókniny lub agrotkaniny oraz jej mocowanie',
      'Montaż obrzeży (np. ekobordów lub krawężników z kostki)',
      'Sadzenie roślin: drzewa, krzewy, byliny, pnącza',
      'Wypełnienie rabat: korą, żwirem lub kamieniem dekoracyjnym',
      'Układanie trawnika z siewu (z nawożeniem startowym)',
      'Układanie trawnika (z przygotowaniem podłoża)'
    ],
    'Zakładanie i pielęgnacja trawnika': [
      'Wertykulacja – usunięcie warstwy filcu i martwych szczątków organicznych',
      'Aeracja – napowietrzenie gleby (kołkowa lub korkowa)',
      'Nawożenie mineralne i organiczne',
      'Piaskowanie trawnika',
      'Dosiew trawy po zabiegach regeneracyjnych',
      'Koszenie kosiarką tradycyjną',
      'Koszenie kosą spalinową (w trudno dostępnych miejscach)',
      'Grabienie liści i utrzymanie czystości'
    ],
    'Pielęgnacja ogrodu': [
      'Formowanie żywopłotów i szpalerów (do 2 m / do 4 m)',
      'Przycinanie drzew, krzewów i bonsai',
      'Opryski przeciw chorobom grzybowym i szkodnikom',
      'Ręczne odchwaszczanie rabat',
      'Nawożenie roślin z dostosowaniem do gatunku',
      'Karczowanie niepożądanych drzew i krzewów',
      'Wywóz i utylizacja odpadów zielonych',
      'Pielęgnacja sezonowa: wiosenna, letnia, jesienna, zimowa'
    ]
  },
  'Nawodnienie ogrodu': {
    'Etap przygotowawczy i projektowy': [
      'Konsultacja z inwestorem i analiza działki',
      'Ustalenie preferencji inwestora',
      'Określenie rodzaju roślin i proporcji trawnika do roślin ozdobnych',
      'Analiza gleby, nasłonecznienia i zacienienia działki',
      'Inwentaryzacja terenu i różnicy wysokości',
      'Analiza głębokości lustra wody w studni oraz parametrów źródła wody',
      'Wydajność dynamiczna źródła oraz ciśnienie dynamiczne na wyjściu',
      'Sprawdzenie okresowych spadków ciśnienia w sieci',
      'Projekt wykonawczy systemu',
      'Dobór rodzaju sterownika (WiFi lub bez, bateryjny lub nie)',
      'Określenie lokalizacji sterownika – wewnątrz czy na zewnątrz budynku',
      'Ustalenie punktów poboru wody i ich lokalizacji (np. szybkozłączki w kostce lub trawniku)',
      'Tabela z technicznymi parametrami systemu',
      'Informacje o posiadanej pompie lub dobranie odpowiedniej pompy',
      'Określenie źródła wody: wodociąg, studnia, zbiornik deszczówki'
    ],
    'Projektowanie hydrauliki i automatyki': [
      'Projekt hydrauliki',
      'Ustalenie trasy głównych i bocznych linii nawadniania',
      'Obliczenia hydrauliczne: analiza strat ciśnienia (na rurach, złączkach, elektrozaworach)',
      'Analiza spadków terenu pod kątem pracy systemu',
      'Dobór średnic rur, typów zraszaczy i linii kroplujących',
      'Dobór zaworu kulowego do odcinania dopływu wody na czas konserwacji',
      'Projekt automatyki',
      'Dobór elektrozaworów, kolektora i studzienki',
      'Montaż zaworu zabezpieczającego przed zalaniem w przypadku awarii',
      'Dobór czujnika pogody',
      'Zaprogramowanie sterownika i czujnika'
    ],
    'Etap wykonawczy – montaż systemu': [
      'Prace ziemne',
      'Wykopy pod rury i linie kroplujące',
      'Montaż instalacji',
      'Układanie rur głównych i bocznych',
      'Podłączenie systemu do instalacji wodnej i elektrycznej',
      'Montaż złączek, trójników i innych połączeń rurowych',
      'Montaż elementów systemu zraszającego',
      'Montaż zraszaczy małego, średniego i dużego zasięgu',
      'Montaż mikro zraszaczy',
      'Montaż linii kroplujących (czarne i brązowe, z kompensacją i bez, naziemne i podziemne)',
      'Podłączenie zraszaczy do rur głównych',
      'Montaż odpowietrzników i wskaźników pracy linii kroplujących',
      'Montaż automatyki i specjalnych komponentów',
      'Montaż elektrozaworów i kolektora',
      'Montaż zaworu kulowego odcinającego dopływ wody',
      'Montaż dozownika nawozów',
      'Montaż zaworu antyzalaniowego'
    ],
    'Etap testowania i szkolenia': [
      'Testy systemu',
      'Uruchomienie systemu i sprawdzenie poprawności działania wszystkich stref',
      'Test przepływu i ciśnienia',
      'Przekolenie Inwestora',
      'Przeszkolenie z zakresu obsługi sterowania i konserwacji systemu',
      'Przekazanie dokumentacji powykonawczej i ustawień sterownika'
    ]
  },
  'Oświetlenie ogrodu': {
    'Projekt koncepcyjny i planowanie': [
      'Inwentaryzacja terenu (układ roślinności, elementy małej architektury)',
      'Ustalenie preferencji inwestora (styl, kolor światła, rodzaj oświetlenia)',
      'Określenie stref funkcjonalnych (ciągi komunikacyjne, strefy relaksu, punkty akcentowe)',
      'Ustalenie budżetu inwestycji',
      'Dobór typu oświetlenia: punktowe, liniowe, reflektory, lampy dekoracyjne',
      'Analiza źródeł zasilania (230V, niskonapięciowe, solarne)',
      'Określenie rodzaju sterowania: ręczne, z czujnikiem zmierzchu, czasowe, aplikacja Wi-Fi',
      'Ustalenie miejsc montażu opraw oświetleniowych'
    ],
    'Projekt wykonawczy': [
      'Wykonanie planu instalacji elektrycznej z oznaczeniem tras kabli i punktów oświetleniowych',
      'Określenie przekroju i długości przewodów',
      'Wybór odpowiednich opraw oświetleniowych z uwzględnieniem IP',
      'Dobór transformatorów (dla systemów 12V)',
      'Określenie liczby i mocy źródeł światła',
      'Dobór zabezpieczeń elektrycznych (wyłączniki różnicowoprądowe, bezpieczniki)',
      'Sporządzenie kosztorysu inwestorskiego'
    ],
    Wykonawstwo: [
      'Wykopanie tras kablowych i ułożenie rur ochronnych',
      'Ułożenie kabli i montaż puszek instalacyjnych',
      'Montaż lamp oświetleniowych w wyznaczonych punktach',
      'Instalacja sterownika i/lub czujników zmierzchu',
      'Podłączenie do źródła zasilania',
      'Test działania systemu'
    ],
    'Odbiór i przeszkolenie': [
      'Sprawdzenie poprawności działania wszystkich punktów świetlnych',
      'Pomiar napięcia i natężenia',
      'Kontrola zabezpieczeń i szczelności instalacji',
      'Instruktaż z obsługi sterowania (manualnego, zdalnego, harmonogramów)',
      'Przekazanie dokumentacji powykonawczej'
    ]
  }
}
